module.exports = __webpack_public_path__ + "img/tie-1.e1f9ad48.png";